import { VerificationCardTypeTokens, IconTokens, VerificationCardButtonTypeToken, } from '@voltmoney/schema';
export const args = {
    label: 'Account Verified Successfully',
    message: 'You will be redirected to next step',
    type: VerificationCardTypeTokens.Success,
    buttonType: VerificationCardButtonTypeToken.FULL,
    buttonText: 'Submit',
    //width: ButtonWidthTypeToken.CONTENT,
};
export const argTypes = {
    type: {
        control: 'select',
        options: [
            ...Object.values(VerificationCardTypeTokens).filter((k) => typeof k === 'string'),
        ],
    },
    iconName: {
        control: 'select',
        options: [
            null,
            ...Object.values(IconTokens).filter((k) => typeof k === 'string'),
        ],
    },
    buttonType: {
        control: 'select',
        options: [
            ...Object.values(VerificationCardButtonTypeToken),
        ],
    },
    icon: {
        default: null,
        control: 'object',
        options: [...Object.values(IconTokens)],
    },
    baseIcon: {
        default: null,
        control: 'object',
        options: [...Object.values(IconTokens)],
    },
    onPress: { action: 'clicked' },
};
